<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="receipt"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_8203" data-name="Path 8203" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_8204"
      data-name="Path 8204"
      d="M16,7H8m8.13,4H8M4,19.191V4A1,1,0,0,1,5,3H19a1,1,0,0,1,1,1V19.191a.5.5,0,0,1-.724.447l-1.943-.972L14.89,19.888a.5.5,0,0,1-.447,0L12,18.667,9.557,19.889a.5.5,0,0,1-.447,0L6.667,18.667l-1.943.972A.5.5,0,0,1,4,19.191ZM13,15H8"
      fill="none"
      :stroke="clr ? clr : '#fff'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
